document.addEventListener('DOMContentLoaded', function () {

    function getStep(card){
  const s = parseInt(card.getAttribute('data-step') || '1', 10);
  return isNaN(s) || s < 1 ? 1 : s;
}
function clampToStep(val, step){
  val = parseInt(val || '0', 10);
  if (isNaN(val) || val < 0) val = 0;
  // on aligne sur le multiple inférieur du step (0,10,20…)
  return Math.floor(val / step) * step;
}


  // ---- LIMITE EFFECTIVE POUR LE PLUS/MOINS ----
  function getLimitForPlus(card){
    const isPre   = String(card.getAttribute('data-preorder-live')) === 'true';
    const stock   = parseInt(card.getAttribute('data-max-quantity') || '0', 10);
   const cap = parseInt(card.getAttribute('data-preorder-cap') || '0', 10);
    if (isPre && stock <= 0) return cap > 0 ? cap : 999999; // préco sans limite front si cap non défini
    return stock; // cas normal: stock
  }

  function updateRollNote(card){
  // On n’affiche que pour le type Nicotine Pouches
  const type = (card.getAttribute('data-type') || '').toLowerCase();
  //if (!type || type !== 'nicotine-pouches') return;
  if (!type || type !== 'nicotine-pouches') return;

  const input = card.querySelector('.quantity-input');
  const note  = card.querySelector('.roll-note');
  if (!input || !note) return;

  const val = parseInt(input.value || '0', 10) || 0;
  note.style.display = val > 0 ? 'block' : 'none';
}



// Bouton + (CORRIGÉ avec step)
  document.querySelectorAll('.plus-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      const card = button.closest('.product-card');
      const quantityInput = card.querySelector('.quantity-input');
      const step = getStep(card);
      const limitForPlus = getLimitForPlus(card);

      const current = parseInt(quantityInput.value) || 0;
      let next = current + step;

      if (next > limitForPlus) {
        // Si on dépasse, on aligne sur le multiple inférieur
        if (step > 1) {
          next = clampToStep(limitForPlus, step);
        } else {
          next = limitForPlus;
        }
        const isPre = String(card.getAttribute('data-preorder-live')) === 'true';
        if (current >= next) {
          alert(isPre ? "Vous avez atteint la quantité maximale de pré-commande." :
                        "Vous ne pouvez pas ajouter d'autres articles au panier.");
          return;
        }
      }

      quantityInput.value = next;

      updateAddButtonState(
        card.getAttribute('data-variant-id'),
        card.getAttribute('data-max-quantity')
      );
      updateRollNote(card);
    });
  });


  // Bouton - (CORRIGÉ avec step)
  document.querySelectorAll('.minus-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      const card = button.closest('.product-card');
      const quantityInput = card.querySelector('.quantity-input');
      const step = getStep(card);

      const current = parseInt(quantityInput.value) || 0;
      let next = current - step;
      if (next < 0) next = 0;

      quantityInput.value = next;

      updateAddButtonState(
        card.getAttribute('data-variant-id'),
        card.getAttribute('data-max-quantity')
      );
      updateRollNote(card);
    });
  });

  // Mise à jour du bouton "Ajouter" (garde ta logique d'origine)
  function updateAddButtonState(variantId, maxQuantity) {
    const quantityInput = document.querySelector('[data-variant-id="' + variantId + '"] .quantity-input');
    const currentQuantity = parseInt(quantityInput?.value) || 0;
    const addButton = document.querySelector('[data-variant-id="' + variantId + '"] .add-button');
    if (!addButton) return; // si carte en précommande: pas de bouton "Ajouter"
    const stockMax = parseInt(maxQuantity || '0', 10);
    addButton.disabled = currentQuantity > stockMax;
  }

  // Ajout au panier (UN SEUL BLOC)
  document.querySelectorAll('.add-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const variantId = button.closest('.product-card').getAttribute('data-variant-id');
      const quantity = parseInt(button.closest('.quantity-validation-wrapper').querySelector('.quantity-input').value) || 0;
      if (quantity > 0) addToCart(variantId, quantity);
    });
  });

function addToCart(variantId, quantity) {
  const card = document.querySelector('[data-variant-id="' + variantId + '"]');
  const addButton = card.querySelector('.add-button');
  const group = card.getAttribute('data-limit-group'); // ← "ecigs" ou vide
  addButton.textContent = '...';

  // Si groupe → on passe par fetch pour envoyer la propriété; sinon on garde Shopify.addItem
  if (group) {
    const body = new URLSearchParams();
    body.append('id', variantId);
    body.append('quantity', quantity);
    body.append('properties[_limit_group]', group);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString()
    })
    .then(r => r.ok ? r.json() : Promise.reject(r))
    .then(() => afterAddSuccess(card, addButton, variantId))
    .catch(() => restoreBtn(addButton));
  } else {
    Shopify.addItem(variantId, quantity, function () {
      afterAddSuccess(card, addButton, variantId);
    });
  }

  function afterAddSuccess(card, addButton, variantId){
    addButton.innerHTML = '<span class="checkmark-icon"><svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.5 10l3 3 7-7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

    const input = card.querySelector('.quantity-input');
    if (input) input.value = 0;
    if (typeof updateRollNote === 'function') updateRollNote(card);

    if (window.Shopify && typeof Shopify.getCart === 'function') Shopify.getCart();
    document.dispatchEvent(new CustomEvent('cart:updated'));

    setTimeout(() => { addButton.textContent = 'Ajouter'; }, 1200);
  }

  function restoreBtn(addButton){
    addButton.textContent = 'Ajouter';
    addButton.disabled = false;
    alert("Erreur d'ajout au panier");
  }
}
});


/*Empêcher la saisie clavier > cap en préco*/
document.addEventListener('input', function(e){
  const input = e.target.closest('.quantity-input');
  if(!input) return;
  const card = e.target.closest('.product-card');
  if(!card) return;

  const isPre   = String(card.getAttribute('data-preorder-live')) === 'true';
  const stock   = parseInt(card.getAttribute('data-max-quantity') || '0', 10);
  const cap = parseInt(card.getAttribute('data-preorder-cap') || '0', 10);
  const step = parseInt(card.getAttribute('data-step') || '1', 10);

  let max = stock;
  if(isPre && stock <= 0){ max = cap > 0 ? cap : 999999; }

  // Fonction clampToStep locale pour cet écouteur
  function clampToStepLocal(val, step){
    val = parseInt(val || '0', 10);
    if (isNaN(val) || val < 0) val = 0;
    return Math.floor(val / step) * step;
  }

  let val = clampToStepLocal(input.value, step);
  if(val > max) val = clampToStepLocal(max, step);
  input.value = String(val);

  // Afficher/masquer "rouleau de 10" si applicable
  const type = (card.getAttribute('data-type') || '').toLowerCase();
  const note = card.querySelector('.roll-note');
  if (type === 'nicotine-pouches' && note) {
    note.style.display = val > 0 ? 'block' : 'none';
  }
});

/***
Ajoute/modifie le script pour qu’il :
filtre les .product-card
cache les .product-block et .vendor-block si aucun enfant visible
***/

document.addEventListener("DOMContentLoaded", function () {
  const vendorFilter = document.getElementById("vendor-filter");
  const typeFilter = document.getElementById("type-filter");

  function applyFilters() {
    const selectedVendor = vendorFilter.value;
    const selectedType = typeFilter.value;
    const cards = document.querySelectorAll(".product-card");

    cards.forEach(card => {
      const cardVendor = card.dataset.vendor;
      const cardType = card.dataset.type;

      const matchVendor = selectedVendor === "all" || cardVendor === selectedVendor;
      const matchType = selectedType === "all" || cardType === selectedType;

      card.style.display = (matchVendor && matchType) ? "block" : "none";
    });

// cacher les product-blocks sans produit visible
document.querySelectorAll(".product-block").forEach(block => {
  const hasVisible = block.querySelector(".product-card[style*='display: block']");
  block.style.display = hasVisible ? "block" : "none";
});

// cacher les vendor-blocks sans produit visible
document.querySelectorAll(".vendor-block").forEach(block => {
  const hasVisible = block.querySelector(".product-card[style*='display: block']");
  block.style.display = hasVisible ? "block" : "none";
});

  }

  vendorFilter.addEventListener("change", applyFilters);
  typeFilter.addEventListener("change", applyFilters);
});

